@for(bookingServices of bookingServicesViewModel; track bookingServicesViewModel){
@if((bookingServices.servicesOutbound)){
<vy-box [boxLevel]="boxLevelEnum.LEVEL_TWO" [hasMarginBottom]="true">
  <ng-container box-content>
    <div class="marginBottom-m">
      <div class="vy-booking-details_container">
        <div class="vy-booking-details_content-wrap">
          <vy-avatar-name
            [avatarInput]="bookingServices.passengerAvatar"
            [label]="!!bookingServices.hasInfant ? 'booking_details_component.booking_services_component.baby' : undefined"
          ></vy-avatar-name>
        </div>
        <div
          class="{{bookingServices.servicesInbound ? 'vy-booking-details_content-wrap' : 'vy-booking-details_content-wrap-ow'}}"
        >
          <h2 dynamicTitle tag="h3" class="marginBottom-m">
            <vy-route-title
              [config]="{origin: { iata: 'ds.basket.flightInfo.departure.normal' | translate }}"
              [accessibilityId]="'paxlist-header'"
            >
            </vy-route-title>
          </h2>
          <div class="vy-booking-details_content_list">
            <ul vy-list [iconSmall]="true" [listSize]="listSizeEnum.M">
              @for(item of bookingServices.servicesOutbound; track item){
              <li
                vy-list-item
                [listSize]="listSizeEnum.M"
                [disabled]="item.count === 0"
                [separated]="true"
                [customIconClass]="item.icon"
                class="marginBottom-m"
              >
                <span vyListItemLabel [innerHTML]="item.label | translate : {amount: item.count}"></span>
                @if(showCheck(item.label, item.count)){
                <span vyListItemCustomComponent>
                  <vy-icon [type]="iconTypeEnum.SUCCESS" [size]="iconSizeEnum.S" icon="ds-icon-ok"></vy-icon> </span
                >}@else {
                <span vyListItemCustomComponent>
                  <vy-icon [type]="iconTypeEnum.DANGER" [size]="iconSizeEnum.S" icon="ds-icon-close"></vy-icon>
                </span>
                }
              </li>
              }
            </ul>
          </div>
        </div>
        @if(bookingServices.servicesInbound){
        <div class="vy-booking-details_content-wrap">
          <h2 dynamicTitle tag="h3" class="marginBottom-m">
            <vy-route-title
              [config]="{destination: { iata: 'ds.basket.flightInfo.arrival.normal' | translate  },
                isReturn: true}"
              [accessibilityId]="'paxlist-header'"
            >
            </vy-route-title>
          </h2>
          <div class="vy-booking-details_content_list">
            <ul vy-list [iconSmall]="true" [listSize]="listSizeEnum.M">
              @for(item of bookingServices.servicesInbound; track item){
              <li
                vy-list-item
                [listSize]="listSizeEnum.M"
                [disabled]="item.count === 0"
                [separated]="true"
                [customIconClass]="item.icon"
                class="marginBottom-m"
              >
                <span vyListItemLabel [innerHTML]="item.label | translate: {amount: item.count}"></span>
                @if(showCheck(item.label, item.count)){
                <span vyListItemCustomComponent>
                  <vy-icon [type]="iconTypeEnum.SUCCESS" [size]="iconSizeEnum.S" icon="ds-icon-ok"></vy-icon> </span
                >}@else {
                <span vyListItemCustomComponent>
                  <vy-icon [type]="iconTypeEnum.DANGER" [size]="iconSizeEnum.S" icon="ds-icon-close"></vy-icon>
                </span>
                }
              </li>
              }
            </ul>
          </div>
        </div>
        }
      </div>
    </div>
  </ng-container>
</vy-box>

} }
